<!-- ---------------------------------- NEW ITINERARY -------------------------- -->
<div class="section-topextend align-items-center justify-content-center h-100" *ngIf="!reload && !chargeClient">
  <a class="loader text-center justify-content-center align-items-center h-100">
    <i class="fas fa-spinner fa-spin"></i><span class="ml-2">Cargando, espere por favor...</span>
  </a>
</div>

<ng-container *ngIf="reload">
  <div class="section-topextend h-100 w-100 mx-auto" *ngIf="!saved && loaded" style="max-width: 1440px;" [ngStyle]="{ 'background-color': sectionHeader?.background_itinerary_owner }">
    <div class="d-flex justify-content-between container-fluid align-items-center h-100 w-100">
      <div class="w-100">
        <form [formGroup]="_formGroupItinerary" style="height: 45px" class="d-flex align-items-center justify-content-between w-100">
          <!-- Input File Name -->
          <span class="d-flex align-items-center justify-content-center" style="gap: 10px">
            <img src="../../../assets/icons/header/navbar/ICONOS TOP-08-01.svg" width="25" height="25" />
            <input
              #itineraryName
              class="form-control menu-sesion input-header me-2 pl-2"
              style="width: 170px; height: 35px !important; border-radius: 8px;"
              type="text"
              placeholder="Nombre File"
              name="title"
              aria-label="Title"
              formControlName="title"
              maxlength="50"
              autocomplete="off"
            />
          </span>

          <!-- Input Client Name -->
          <span id="autocomplete-container" class="d-flex align-items-center justify-content-center" style="margin-left: 15px; gap: 10px">
            <img src="../../../assets/icons/header/navbar/ICONOS TOP-07.svg" width="25" height="25" />

            <input
              #name
              class="form-control menu-sesion input-header me-2"
              style="width: 170px; height: 35px !important; border-radius: 8px;"
              type="text"
              placeholder="Nombre Cliente"
              name="client"
              formControlName="name"
              (keydown)="blockInvalidKeys($event, 'name')"
              (paste)="$event.preventDefault()"
              (drop)="$event.preventDefault()"
              (contextmenu)="$event.preventDefault()"
              maxlength="50"
              autocomplete="off"
              aria-label="Name"
            />
          </span>
          <span class="d-flex px-0 align-items-center justify-content-start" style="margin-left: 15px; gap: 10px">
            <img src="../../../assets/icons/header/navbar/ICONOS TOP-09.svg" width="25" height="25" />

            <input
              #email
              class="form-control menu-sesion input-header me-2"
              style="width: 200px; height: 35px !important; border-radius: 8px;"
              type="text"
              maxlength="50"
              placeholder="E-mail"
              name="email"
              (ngModelChange)="resetSaveFormFields(clientLoaded)"
              formControlName="email"
              autocomplete="off"
              aria-label="Mail"
            />

            <button
              type="submit"
              class="btn btn-sm btn-search"
              style="margin-left: -5px; width: 35px; height: 35px !important; border-radius: 8px; padding: 0px 5px;"
              data-placement="bottom"
              (click)="openModalExtraLarge()"
            >
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 658.4 595.4" style="width: 40px; height: 40px; position: absolute;" xml:space="preserve"><path d="M407.5,346.7c14.3-20,22.6-44.5,22.6-70.9c0-67.5-54.9-122.4-122.4-122.4s-122.4,54.9-122.4,122.4s54.9,122.4,122.4,122.4 c26,0,50.1-8.1,69.9-22l59.7,59.7c4.1,4.1,9.5,6.2,14.8,6.2s10.7-2,14.8-6.2c8.2-8.2,8.2-21.5,0-29.7L407.5,346.7z M227.4,275.8 c0-44.3,36.1-80.4,80.4-80.4s80.4,36.1,80.4,80.4s-36.1,80.4-80.4,80.4S227.4,320.2,227.4,275.8z"/> </svg>
            </button>
          </span>
          <span class="d-flex align-items-center justify-content-start" style="margin-left: 15px; gap: 5px; margin-right: 10px !important;">
            <img src="../../../assets/icons/header/navbar/ICONOS TOP-06-01.svg" width="25" height="25" />

            <ng-container *ngIf="_formGroupItinerary.get('phone_code').value === null">
              <input
                id="phone_code"
                name="phone_code"
                matInput
                class="form-control menu-sesion input-header me-2 no-spinner"
                style="
                  font-family: &quot;Poppins&quot;, sans-serif !important;
                  font-size: 13px;
                  font-weight: 500 !important;
                  padding-left: 15px;
                  padding-top: 5px;
                  width: 200px;
                  margin-top: 1px;
                  height: 35px !important;
                  color: #464646;
                  border-radius: 8px;
                "
                aria-label="phone_code"
                [matAutocomplete]="auto"
                (input)="filterCountries($event.target.value)"
                (focus)="getCountries()"
                (paste)="$event.preventDefault()"
                (drop)="$event.preventDefault()"
                (contextmenu)="$event.preventDefault()"
                (keydown)="blockInvalidKeys($event, 'name')"
                autocomplete="off"
                placeholder="País + Cod. telefónico"
              />
              <mat-autocomplete
                id="matCountry"
                #matCountry
                #auto="matAutocomplete"
                (optionSelected)="updateMySelectionNationality($event.option.value)"
                [displayWith]="displayCountry"
              >
                <mat-option *ngFor="let country of filteredCountries" [value]="country.phone_code">
                  {{ country.country_name }}
                </mat-option>
              </mat-autocomplete>
            </ng-container>

            <span *ngIf="_formGroupItinerary.get('phone_code').value !== null" style="position: relative">
              <span class="container-input-icon-cancel">
                <input
                  id="phone_code"
                  name="phone_code"
                  matInput
                  class="form-control menu-sesion input-header me-2 no-spinner"
                  style="
                    font-family: &quot;Poppins&quot;, sans-serif !important;
                    font-size: 13px;
                    font-weight: 500 !important;
                    padding-left: 15px;
                    padding-top: 5px;
                    width: 180px;
                    margin-top: 1px;
                    height: 35px !important;
                    color: #464646;
                    background-color: white;
                    border-radius: 8px;
                  "
                  aria-label="phone_code"
                  autocomplete="off"
                  value="{{ phoneCodeSelected }}"
                  readonly
                />
                <span class="square-class-secondArrival">
                  <div class="container-square-secondArrival">
                    <i
                      class="bi bi-x x-icon-cancel"
                      (mouseenter)="isHoveredCancelDate = true"
                      (mouseleave)="isHoveredCancelDate = false"
                      tooltip="Eliminar código telefónico"
                      placement="bottom"
                      (click)="resetPhoneCode()"
                    ></i>
                  </div>
                </span>
              </span>
            </span>

            <input
              #phone
              class="form-control menu-sesion input-header me-2 no-spinner"
              style="width: 150px; height: 35px; border-radius: 8px;"
              type="number"
              (keydown)="blockInvalidKeys($event, 'number')"
              (paste)="$event.preventDefault()"
              (drop)="$event.preventDefault()"
              (contextmenu)="$event.preventDefault()"
              placeholder="N° Teléfono"
              name="phone"
              formControlName="phone"
              autocomplete="off"
              aria-label="Phone"
            />
          </span>
          <button
            type="submit"
            class="btn btn-sm btn-save-client d-flex align-items-center justify-content-center"
            data-placement="bottom"
            style="font-size: 13px; font-family: 'Rubik'; font-weight: 500; padding: 10px 0px; background-color:
            #d5f9ed; width: 150px; border-radius: 20px; height: 35px !important; border: 1px solid #000000;"
            (click)="saveFirstItinerary()"
            *ngIf="this.clientLoaded"
          >
            Guardar
          </button>
          <button
            type="submit"
            class="btn btn-sm btn-save-client d-flex align-items-center justify-content-center"
            data-placement="bottom"
            style="font-size: 13px; font-family: 'Rubik'; font-weight: 500; padding: 10px 0px; background-color:
            #d5f9ed; width: 150px; border-radius: 20px; height: 35px !important; border: 1px solid #000000;"
            (click)="verifyExist()"
            *ngIf="!this.clientLoaded"
          >
            Guardar
          </button>
          <div *ngIf="currencyAgency" class="d-flex ml-2 align-items-center">
            <span
              class="menu-sesion input-header"
              style="display: flex; align-items: center; width: auto"
              [ngStyle]="{ color: sectionHeader?.icon_color }"
              >Moneda:&nbsp;</span
            >
            <span
              class="menu-sesion input-header"
              style="display: flex; align-items: center; width: auto; font-weight: 400 !important;"
              [ngStyle]="{ color: sectionHeader?.icon_color }"
              >{{ currencyAgency?.code }}</span
            >
            <div *ngIf="currencyAgency && currencies && currencies.length > 0" class="info-tool d-flex flex-column position-relative">
              <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                viewBox="0 0 89 89" style="width: 12px;" xml:space="preserve">
                <style type="text/css">
                  .st0{fill:#FFFFFF;}
                </style>
                <g>
                  <g>
                    <circle class="st0" cx="44.5" cy="44.5" r="44.5"/>
                  </g>
                  <g>
                    <path d="M44.4,71.5c-4.1,0-6.9-3.1-6.9-7.2c0-4.3,2.9-7.2,7.1-7.2s6.9,2.9,7,7.2c0,4.1-2.8,7.2-7,7.2H44.4z M40,53.2l-1.7-35.8
                      h12.5L49,53.2H40z"/>
                  </g>
                </g>
              </svg>
              <span class="tooltip-info shadow-md">
                <table>
                  <tr>
                    <th style="text-align: center">
                      <p>USD</p>
                    </th>
                    <th style="text-align: center">
                      <p>{{ currencyAgency?.code }}</p>
                    </th>
                    <th style="text-align: center">
                      <p>Ultima actualización</p>
                    </th>
                  </tr>
                  <!-- <ng-container *ngFor="let currency of currencies"> -->
                  <tr>
                    <td>
                      <p>USD 1.00</p>
                    </td>
                    <td>
                      <p>{{ currencyAgency?.code }} {{ currencyAgency?.rate | number: "1.2-2" }}</p>
                    </td>
                    <td>
                      <p>{{ currencyAgency?.updated_at | date: "dd/MM/yyyy, h:mm a" }}</p>
                    </td>
                  </tr>
                  <!-- </ng-container> -->
                </table>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</ng-container>
<!-- ---------------------------------- ERROR FORM -------------------------- -->

<div class="error error-container">
  <div>
    <span *ngIf="_formGroupItinerary.get('title').touched && _formGroupItinerary.get('title').hasError('required')">
      El campo "Nombre del file" es obligatorio.
    </span>

    <span *ngIf="_formGroupItinerary.get('title').touched && _formGroupItinerary.get('title').hasError('spaceOnlyBlank')">
      El campo no acepta sólo espacios en blanco.
    </span>
  </div>

  <div>
    <span
      *ngIf="
        !_formGroupItinerary.get('name').hasError('required') &&
        _formGroupItinerary.get('name').touched &&
        _formGroupItinerary.get('name').hasError('invalidname')
      "
    >
      Por favor ingrese un nombre completo válido. Ejemplo: 'Primero Último'.
    </span>

    <span
      *ngIf="
        !_formGroupItinerary.get('email').hasError('required') &&
        _formGroupItinerary.get('email').touched &&
        _formGroupItinerary.get('email').hasError('invalidemail')
      "
    >
      Por favor ingrese un formato de correo electrónico válido. Ejemplo: 'mi.usuario@dominio.com'.
    </span>
  </div>

  <div>
    <span
      *ngIf="
        (!_formGroupItinerary.get('email').hasError('required') &&
          _formGroupItinerary.get('email').touched &&
          _formGroupItinerary.get('email').hasError('emailTaken')) ||
        clientEmailTake
      "
    >
      Este correo electronico ya esta en uso.
    </span>
  </div>

  <div>
    <span
      *ngIf="
        !_formGroupItinerary.get('phone').hasError('required') &&
        _formGroupItinerary.get('phone').touched &&
        _formGroupItinerary.get('phone').hasError('pattern') &&
        !isPhoneValidating
      "
    >
      Ingrese su número incluyendo el código de área (sin 0 inicial). El número debe tener al menos 6 caracteres.
    </span>
  </div>

  <div>
    <span
      style="color: #3498db !important"
      *ngIf="!_formGroupItinerary.get('phone').hasError('required') && _formGroupItinerary.get('phone').touched && isPhoneValidating"
    >
      Verificando número...
    </span>
  </div>

  <div>
    <span *ngIf="_formGroupItinerary.get('phone')?.hasError('invalidPhone') && _formGroupItinerary.get('phone')?.touched">
      El número ingresado no es válido.
    </span>
  </div>
</div>

<!-- ---------------------------------- iTINERARY CLIENT -------------------------- TODO ACA-->

<div class="section-topextend" *ngIf="!loaded && chargeClient">
  <a class="loader text-center justify-content-center align-items-center" style="padding-top: 0.5em">
    <i class="fas fa-spinner fa-spin"></i><span class="ml-2">Cargando cliente, espere por favor...</span>
  </a>
</div>

<ng-container *ngIf="reload">
  <nav id="new-itinerary" class="section-topextend mt-0 py-3 w-100 mx-auto" *ngIf="saved && loaded" [ngStyle]="{ 'background-color': sectionHeader?.background_itinerary_owner }" style="max-width: 1440px;">
    <div class="d-flex justify-content-between container-fluid align-items-center">
      <form [formGroup]="_formGroupItinerary" style="height: 45px; width: 100%" class="d-flex align-items-center">
        <div class="d-flex justify-content-between w-100">
          <div class="d-flex justify-content-start" style="gap: 10px;">
            <!-- FILE NUMBER -->
            <div class="d-flex flex-row align-items-center mr-2" style="gap: 10px;">
              <span
                class="d-flex align-items-center menu-item--text rubik semi-bold"
                [ngStyle]="{ color: sectionHeader?.color }"
              >
                FILE N°
              </span>
              <span
                class="menu-item--text rubik semi-bold"
                [ngStyle]="{ color: sectionHeader?.color }"
                style="display: flex; align-items: center;"
                >{{ userService.itineraryActive && userService.itineraryActive.length > 0 ? userService.itineraryActive[0].id : "" }}</span
              >
            </div>

            <!-- File Title -->
            <div class="d-flex align-items-center" style="margin-right: 15px; gap: 10px;">
              <img src="../../../assets/icons/header/navbar/ICONOS TOP-08-01.svg" alt="" width="18" height="18"/>

              <span
                class="menu-item--text"
                [ngStyle]="{ color: sectionHeader?.color }"
                style="display: flex; align-items: center"
                >{{ title.value }}</span
              >
            </div>

            <!-- File User Name -->
            <div class="d-flex align-items-center" style="margin-right: 15px; gap: 10px;">
              <img src="../../../assets/icons/header/navbar/ICONOS TOP-07.svg" alt="" width="18" height="18"/>

              <span
                class="menu-item--text"
                [ngStyle]="{ color: sectionHeader?.color }"
                style="display: flex; align-items: center"
                >{{ name.value }}</span
              >
            </div>

            <!-- File User Email -->
            <div class="d-flex align-items-center" style="margin-right: 15px; gap: 10px;">
              <img src="../../../assets/icons/header/navbar/ICONOS TOP-09.svg" alt="" width="18" height="18"/>

              <span
                class="menu-item--text"
                [ngStyle]="{ color: sectionHeader?.color }"
                style="display: flex; align-items: center; width: auto"
                >{{ email.value }}</span
              >
            </div>

            <!-- File User Phone -->
            <div class="d-flex align-items-center" style="margin-right: 15px; gap: 10px;">
              <img src="../../../assets/icons/header/navbar/ICONOS TOP-06-01.svg" alt="" width="18" height="18"/>

              <span
                class="menu-item--text"
                [ngStyle]="{ color: sectionHeader?.color }"
                style="display: flex; align-items: center"
                >{{ phoneCodeClient(phone_code.value) }} {{ phone.value }}</span
              >
            </div>
          </div>

          <!-- Dates and buttons -->
          <div
            class="d-flex align-items-center justify-content-end"
            style="max-width: 625px; min-width: 420px"
            *ngIf="userService.itineraryActive.length > 0"
          >
            <div
              class="d-flex"
              style="margin-right: 12px"
              *ngIf="userService?.itineraryActive[0]?.items && userService.itineraryActive[0]?.items?.length > 0"
            >
              <div class="d-flex justify-content-end cursor-pointer mr-2">
                <span
                  class="menu-item--text"
                  [ngStyle]="{ color: sectionHeader?.color }"
                  *ngIf="userService.itineraryArrivalDate && userService.itineraryDepartureDate"
                >
                  <span style="font-weight: 600;">In: </span> {{ getDateInOut(userService.itineraryArrivalDate) }} / <span style="font-weight: 600;">Out: </span>
                  {{ getDateInOut(userService.itineraryDepartureDate) }}
                </span>
              </div>
            </div>

            <div *ngIf="currencyAgency" class="d-flex">
              <span
                class="menu-item--text"
                style="display: flex; align-items: center; width: auto"
                [ngStyle]="{ color: sectionHeader?.color }"
              >
                <span style="font-weight: 600; display: inline-block; margin-right: 2px;">Moneda: </span> {{ currencyAgency?.code }}
              </span>
              <div *ngIf="currencyAgency && currencies && currencies.length > 0" class="info-tool d-flex flex-column position-relative">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                  viewBox="0 0 89 89" style="width: 12px;" xml:space="preserve">
                  <style type="text/css">
                    .st0{fill:#FFFFFF;}
                  </style>
                  <g>
                    <g>
                      <circle class="st0" cx="44.5" cy="44.5" r="44.5"/>
                    </g>
                    <g>
                      <path d="M44.4,71.5c-4.1,0-6.9-3.1-6.9-7.2c0-4.3,2.9-7.2,7.1-7.2s6.9,2.9,7,7.2c0,4.1-2.8,7.2-7,7.2H44.4z M40,53.2l-1.7-35.8
                        h12.5L49,53.2H40z"/>
                    </g>
                  </g>
                </svg>
                <span class="tooltip-info shadow-md">
                  <table>
                    <tr>
                      <th style="text-align: center">
                        <p>USD</p>
                      </th>
                      <th style="text-align: center">
                        <p>{{ currencyAgency?.code }}</p>
                      </th>
                      <th style="text-align: center">
                        <p>Ultima actualización</p>
                      </th>
                    </tr>
                    <tr>
                      <td>
                        <p>USD 1.00</p>
                      </td>
                      <td>
                        <p>{{ currencyAgency?.code }} {{ currencyAgency?.rate | number: "1.2-2" }}</p>
                      </td>
                      <td>
                        <p>{{ currencyAgency?.updated_at | date: "dd/MM/yyyy, h:mm a" }}</p>
                      </td>
                    </tr>
                  </table>
                </span>
              </div>
            </div>

            <div class="d-flex">
              <div *ngIf="itineraryItems" class="text-end" style="margin-left: 15px">
                <button
                  type="button"
                  class="badge rounded-pill text-white btn-new-itinerary d-flex align-items-center"
                  style="background-color: #FFFFFF; border-radius: 25px; padding: 7px 10px; cursor: pointer;"
                  [ngStyle]="{ border: '1px solid ' + sectionHeader?.icon_color }"
                  data-placement="bottom"
                  title="Go Itinerary"
                  (click)="active()"
                >
                  <div class="d-flex px-1" style="justify-content: space-between; align-items: center; width: 90px">
                    <p
                      class="mb-0 menu-item--text semi-bold"
                      [ngStyle]="{ color: sectionHeader?.color }"
                    >
                      Ver File
                    </p>
                  </div>
                  <div class="d-flex align-items-center justify-content-center" style="border-radius: 50%; background-color: #000000; width: 28px; height: 28px;">
                    <img style="filter: brightness(0) invert(1);" src="../../../assets/icons/header/navbar/folder-02.svg" alt="" width="20" height="20"/>
                  </div>
                </button>
              </div>
              <!-- *ngIf="href == '/home' " -->
              <div class="text-end" style="margin-left: 15px">
                <button
                  id="newItinerary"
                  type="button"
                  class="badge rounded-pill text-white btn-new-itinerary d-flex align-items-center"
                  style="background-color: #FFFFFF; border-radius: 25px; padding: 7px 10px; cursor: pointer;"
                  [ngStyle]="{ border: '1px solid ' + sectionHeader?.icon_color }"
                  data-placement="bottom"
                  title="Nuevo file"
                  (click)="openNewItinerary()"
                >
                  <div class="d-flex px-1" style="justify-content: space-between; align-items: center; width: 90px">
                    <p
                      class="mb-0 menu-item--text semi-bold"
                      [ngStyle]="{ color: sectionHeader?.color }"
                    >
                      Nuevo File
                    </p>
                  </div>

                  <div class="d-flex align-items-center justify-content-center" style="border-radius: 50%; background-color: #000000; width: 28px; height: 28px;">
                    <img style="filter: brightness(0) invert(1);" src="../../../assets/icons/header/navbar/folder-01.svg" alt="" width="20" height="20"/>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </nav>
</ng-container>
<!-------------------------- CREACIÓN DE CLIENTES -------------------------------->

<div *ngIf="clientExists" class="col-10 client-exists client-exists-container">
  <span class="d-flex align-center justify-content-center" style="height: 30px; align-items: center">
    <div class="error-outline"></div>
    <span>Cliente ya existente. Verifique que los datos sean adecuados</span>
  </span>
</div>

<div *ngIf="clientCreated" class="col-10 client-add client-add-container">
  <span class="d-flex align-center justify-content-center" style="height: 30px; align-items: center">
    <!-- mat-icon -->
    <!-- style="font-size: 28px; color: black;margin-bottom: 6px; margin-right: .5em; font-weight: 500 " -->
    <!-- check_circle_outline -->
    <div class="check-outline"></div>
    <span>Cliente creado satisfactoriamente </span>
  </span>
</div>

<div *ngIf="clientConectError" class="col-10 client-error-conect client-error-conect-container">
  <span class="d-flex align-center justify-content-center" style="height: 30px; align-items: center">
    <mat-icon rel="preload" style="font-size: 28px; color: white; margin-bottom: 6px; margin-right: 0.5em; font-weight: 500"
      >highlight_off</mat-icon
    >
    <span>Error al crear el cliente. Intente nuevamente más tarde</span>
  </span>
</div>
